module.exports = __webpack_public_path__ + "img/lunbo03.dbdf9648.jpg";